"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _r10SourceLibrary = require("r10-source-library");
var _react = _interopRequireDefault(require("react"));
var _useDynamicPageNavigation = _interopRequireDefault(require("../../../hooks/dynamic/useDynamicPageNavigation"));
var _services = require("../../../services");
var _HeaderTop = _interopRequireDefault(require("../../shared/HeaderTop"));
var _useUpsellAccessoryState = _interopRequireDefault(require("../../../hooks/upsell/useUpsellAccessoryState"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var UpsellDetailsHeader = function UpsellDetailsHeader() {
  var _useDynamicPageNaviga = (0, _useDynamicPageNavigation.default)(),
    onBack = _useDynamicPageNaviga.onBack;
  var _useUpsellAccessorySt = (0, _useUpsellAccessoryState.default)(),
    removeDisplayedUpsellProductDetails = _useUpsellAccessorySt.removeDisplayedUpsellProductDetails;
  var handleOnBack = function handleOnBack() {
    removeDisplayedUpsellProductDetails();
    onBack();
  };
  return /*#__PURE__*/_react.default.createElement(_HeaderTop.default, {
    id: "upsell-details-header",
    actionComponent: /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.InteractiveIcon, {
      dataAttributes: {
        'data-id': 'modal-arrow-back'
      },
      srText: _services.locale.localeString('Recommendation.IconBack'),
      name: "arrow-left",
      appearance: "primary",
      onClick: handleOnBack
    }),
    isCloseButtonHidden: false
  });
};
var _default = UpsellDetailsHeader;
exports.default = _default;